import {Mesh, MeshBasicMaterial, MeshLambertMaterial, PlaneBufferGeometry, TextureLoader} from 'three';
import CubeBox from './CubeBox';
import {animateFrame} from '../util/TweenUtil';
import {startStayReward, cancelStayReward} from '../util/StayReward';
import photo01 from '../res/photos/photo-01.webp';
import photo11 from '../res/photos/photo-11-thumb.webp';
import photo10 from '../res/photos/photo-10.webp';
import photo02 from '../res/photos/photo-02-thumb.webp';

const photos = [
  {url: photo01, aspect: 800 / 1000},
  {url: photo11, aspect: 192 / 240},
  {url: photo10, aspect: 833 / 1000},
  {url: photo02, aspect: 180 / 240}
];

export default class PhotoBox extends CubeBox {
  constructor(prev, photoIndex) {
    super(prev);
    this.photoIndex = photoIndex;
    const side = this.mesh.material;
    const top = new MeshLambertMaterial({color: 0xfff4df});
    this.mesh.material = [side, side, top, side, side, side];
    const photo = photos[photoIndex];
    // Keep the complete portrait on the top surface with a small frame, without stretching.
    const height = this.size * .94;
    const geometry = new PlaneBufferGeometry(height * photo.aspect, height);
    const texture = new TextureLoader().load(photo.url, () => animateFrame());
    const picture = new Mesh(geometry, new MeshBasicMaterial({map: texture}));
    picture.rotation.x = -Math.PI / 2;
    picture.position.y = this.height + .03;
    this.mesh.add(picture);
  }

  doAnimate(game) {
    startStayReward(this, game, 15, '贴图方块');
  }

  cancelStay() {
    cancelStayReward(this);
  }
}
